module.exports = __webpack_public_path__ + "img/T7A6679.658e7ffe.jpg";